import type { ReactNode } from 'react';
import { DownloadIcon } from '../Icon.tsx';
import type { AppUpdateState } from '../useAppUpdate.ts';

/**
 * Native APK güncellemesi bildirimi.
 *
 * APK otomatik kurulmaz; kullanıcı "APK indir" ile sistem tarayıcısını açar,
 * indirmeyi ve kurulumu Android onayıyla tamamlar.
 */
export function UpdateBanner({ update }: { update: AppUpdateState }): ReactNode {
  if (update.manifest === null) return null;
  return (
    <div className="update-banner" role="status" aria-live="polite">
      <span className="update-banner__icon" aria-hidden="true">
        <DownloadIcon size={18} />
      </span>
      <div className="update-banner__text">
        <strong>Yeni pbfork sürümü: {update.manifest.versionName}</strong>
        <span>
          {update.manifest.notes ?? 'Yeni sürüm hazır. İndirip kurulumu onaylayabilirsiniz.'}
        </span>
      </div>
      <div className="update-banner__actions">
        <button type="button" className="button button--small" onClick={() => void update.open()}>
          APK indir
        </button>
        <button
          type="button"
          className="button button--ghost button--small"
          onClick={update.dismiss}
        >
          Sonra
        </button>
      </div>
    </div>
  );
}
